// Testing permission fix - version bump should now push successfully
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './Store/index.store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import Main from './Main';
import './I18n'

if ('serviceWorker' in navigator) {
  const cfg = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  };
  const params = new URLSearchParams();
  Object.entries(cfg).forEach(([k, v]) => {
    if (v) params.set(k, v);
  });
  // Store the registration promise so getDeviceToken can await it
  (window as any).__swRegistration = navigator.serviceWorker
    .register(`/firebase-messaging-sw.js?${params.toString()}`)
    .catch(function (err) {
      console.error('Service worker registration failed, error:', err);
      return null;
    });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Main />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
